import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
// 是否是小程序
import Drip from 'drip';
import User from 'drip/user';
import Geo from 'drip/geo';
import router from '../router';
import axios from 'axios';
export function isMiniProgram() {
  return !window.Drip.UA.IS_WXAPP_MEITUAN && window.__wxjs_environment === 'miniprogram';
}
function parseQuery(queryString) {
  var query = {};
  if (!queryString) return query;
  try {
    var quries = queryString.split('&');
    if (quries && quries.length) {
      quries.forEach(function (queryItem) {
        var arr = queryItem.split('=');
        query[arr[0]] = arr[1];
      });
    }
    return query;
  } catch (e) {
    console.log('Parse QueryString Fail', e);
    return query;
  }
}

// 解析url参数
export function parseUrl(url) {
  url = decodeURIComponent(url);
  var arr = url.includes('?') ? url.split('?') : [];
  var queryString = '';
  if (arr.length > 1) {
    queryString = arr[1];
  }
  var query = parseQuery(queryString);
  return query;
}

// 获取请求的统一header参数
export function getRequestHeaders() {
  return _getRequestHeaders.apply(this, arguments);
}
function _getRequestHeaders() {
  _getRequestHeaders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var sellChannel, cityId, token, _Drip$UA, osName, appVersion;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          sellChannel = Drip.constant.appType;
          cityId = (Geo.getLocCitySync() || {}).cityId || Drip.constant.cityId || 1;
          token = User.token;
          _Drip$UA = Drip.UA, osName = _Drip$UA.osName, appVersion = _Drip$UA.appVersion;
          return _context2.abrupt("return", {
            sellChannel: sellChannel,
            cityId: cityId,
            token: token,
            clientPlatform: osName,
            clientVersion: appVersion
          });
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getRequestHeaders.apply(this, arguments);
}
export function getFingerPrint() {
  return _getFingerPrint.apply(this, arguments);
}

// 判断登陆
function _getFingerPrint() {
  _getFingerPrint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var fingerPrint, url, query;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return User.getFingerprint();
        case 2:
          fingerPrint = _context3.sent;
          if (isMiniProgram()) {
            //也不明白为啥url里面会有fingerPrint
            url = window.location.href;
            query = parseQuery(url);
            fingerPrint = query['fingerPrint'];
          }
          return _context3.abrupt("return", fingerPrint || null);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getFingerPrint.apply(this, arguments);
}
export function checkLogin() {
  return _checkLogin2.apply(this, arguments);
}
function _checkLogin2() {
  _checkLogin2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (User.isLogin) {
            _context4.next = 3;
            break;
          }
          _context4.next = 3;
          return Drip.login();
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _checkLogin2.apply(this, arguments);
}
export var _checkLogin = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$axios$get, code;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!isMiniProgram()) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return User.getUserInfo();
        case 3:
          if (User.isLogin) {
            _context.next = 13;
            break;
          }
          _context.next = 6;
          return axios.get("/user/desensitizedMobileNo");
        case 6:
          _yield$axios$get = _context.sent;
          code = _yield$axios$get.code;
          if (!(code === 200)) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", true);
        case 12:
          return _context.abrupt("return", false);
        case 13:
          return _context.abrupt("return", true);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function _checkLogin() {
    return _ref.apply(this, arguments);
  };
}();

// 给小程序传参
export function postCurrentPath() {
  wx && wx.miniProgram.postMessage({
    data: {
      path: window.location.href,
      isFromComment: 1
    }
  });
}

// 页面跳转
export function pageTo(path) {
  var _Drip$constant$uaInfo = Drip.constant.uaInfo,
    IS_DIANPING = _Drip$constant$uaInfo.IS_DIANPING,
    IS_MAOYAN = _Drip$constant$uaInfo.IS_MAOYAN,
    IS_MEITUAN = _Drip$constant$uaInfo.IS_MEITUAN;
  if (isMiniProgram()) {
    // 小程序环境
    var currPage = window.location.href.split('#');
    var prefix = currPage[0].includes('pre_login') ? currPage[0] : currPage[0] + '?pre_login';
    path = currPage[0] + '#' + path;
    wx && wx.miniProgram.navigateTo({
      url: "/pages/showsubs/webview/webview?url=".concat(encodeURIComponent(path))
    });
  } else if (IS_DIANPING || IS_MAOYAN || IS_MEITUAN || window.Drip.UA.IS_WXAPP_MEITUAN) {
    // app环境
    Drip.redirect("/myshow/#".concat(path));
  } else {
    // h5环境
    router.push(path);
  }
}

// 页面跳转，小程序是，直接跳往小程序评论编辑页面
// 页面跳转
export function pageToEdit(options) {
  var _Drip$constant$uaInfo2 = Drip.constant.uaInfo,
    IS_DIANPING = _Drip$constant$uaInfo2.IS_DIANPING,
    IS_MAOYAN = _Drip$constant$uaInfo2.IS_MAOYAN,
    IS_MEITUAN = _Drip$constant$uaInfo2.IS_MEITUAN;
  var projectId = options.projectId,
    commentId = options.commentId,
    orderId = options.orderId,
    projectName = options.projectName;
  if (isMiniProgram()) {
    // 小程序环境
    var path = "?projectId=".concat(projectId, "&commentId=").concat(commentId, "&orderId=0&projectName=").concat(projectName);
    wx && wx.miniProgram.navigateTo({
      url: "/pages/showsubs/comments/edit".concat(path)
    });
  } else if (IS_DIANPING || IS_MAOYAN || IS_MEITUAN || window.Drip.UA.IS_WXAPP_MEITUAN) {
    // app环境
    var _path = "/".concat(orderId, "?projectId=").concat(projectId, "&commentId=").concat(commentId);
    Drip.redirect("/myshow/#/comments/edit".concat(_path));
  } else {
    // h5环境
    var _path2 = "/comments/edit/".concat(orderId, "?projectId=").concat(projectId, "&commentId=").concat(commentId);
    router.push(_path2);
  }
}
// 页面替换
export function pageRedirect(path) {
  if (isMiniProgram()) {
    var currPage = window.location.href.split('#');
    var prefix = currPage[0].includes('pre_login') ? currPage[0] : currPage[0] + '?pre_login';
    path = currPage[0] + '#' + path;
    wx && wx.miniProgram.redirectTo({
      url: "/pages/showsubs/webview/webview?url=".concat(encodeURIComponent(path))
    });
  } else {
    router.replace(path);
  }
}

// 页面替换
export function redirectToPage(path) {
  var _Drip$constant$uaInfo3 = Drip.constant.uaInfo,
    IS_DIANPING = _Drip$constant$uaInfo3.IS_DIANPING,
    IS_MAOYAN = _Drip$constant$uaInfo3.IS_MAOYAN,
    IS_MEITUAN = _Drip$constant$uaInfo3.IS_MEITUAN;
  if (isMiniProgram()) {
    // 小程序环境
    var currPage = window.location.href.split('#');
    path = currPage[0] + '#' + path;
    wx && wx.miniProgram.redirectTo({
      url: "/pages/showsubs/webview/webview?url=".concat(encodeURIComponent(path))
    });
  } else if (IS_DIANPING || IS_MAOYAN || IS_MEITUAN || window.Drip.UA.IS_WXAPP_MEITUAN) {
    // app环境
    Drip.redirect("/myshow/#".concat(path), {
      jump: true
    });
  } else {
    // h5环境
    router.replace(path);
  }
}
export function pageBack() {
  var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var _Drip$constant$uaInfo4 = Drip.constant.uaInfo,
    IS_DIANPING = _Drip$constant$uaInfo4.IS_DIANPING,
    IS_MAOYAN = _Drip$constant$uaInfo4.IS_MAOYAN,
    IS_MEITUAN = _Drip$constant$uaInfo4.IS_MEITUAN;
  if (isMiniProgram() || window.Drip.UA.IS_WXAPP_MEITUAN) {
    wx.miniProgram.navigateBack({
      delta: delta
    });
  } else if (IS_DIANPING || IS_MAOYAN || IS_MEITUAN) {
    KNB.closeWebview({});
  } else {
    router.go(-delta);
  }
}
// 日期格式转换
export function dateFormat(timestamp) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy.MM.dd hh:mm';
  // 处理日期展示
  if (timestamp === null || timestamp === undefined) return null;
  var date = new Date(timestamp);
  var year = date.getFullYear();
  var month = date.getMonth() + 1 < 10 ? "0".concat(date.getMonth() + 1) : date.getMonth() + 1;
  var day = date.getDate() < 10 ? "0".concat(date.getDate()) : date.getDate();
  var hour = date.getHours() < 10 ? "0".concat(date.getHours()) : date.getHours();
  var minute = date.getMinutes() < 10 ? "0".concat(date.getMinutes()) : date.getMinutes();
  var second = date.getSeconds() < 10 ? "0".concat(date.getSeconds()) : date.getSeconds();
  var res = type.replace('yyyy', year).replace('MM', month).replace('dd', day).replace('hh', hour).replace('mm', minute).replace('ss', second);
  return res;
}